import { useTheme } from "@/context/ThemeContext";
import { Sun, Moon } from "@phosphor-icons/react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`inline-flex items-center gap-1.5 h-8 px-2.5 border border-border rounded-sm text-xs font-mono uppercase tracking-wide hover:bg-accent transition-colors ${className}`}
    >
      {isDark ? <Sun size={14} /> : <Moon size={14} />}
      <span className="hidden sm:inline">{isDark ? "Light" : "Dark"}</span>
    </button>
  );
}
